// Module
var code = "<p>Bir vekil adınıza oy kullanımını yönetir. BitShares forumunda vekil olarak görev almaya gnüllü kişileri bulabilirsiniz <a href=\"https://bitsharestalk.org/index.php/board,75.0.html\">BitSharestalk</a>. </p> ";
// Exports
export default code;